"use client";

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from "next-intl";
import { Popover, PopoverPanel, Transition } from "@headlessui/react";
import { ArrowRightMini, XMark, BarsThree } from "@medusajs/icons";
import { Text, clx, useToggleState } from "@medusajs/ui";
import { Fragment } from "react";
import ClientLink from "@modules/common/components/client-link";
import CountrySelect from "../country-select";
import LanguageSelect from "../language-select";
import { HttpTypes } from "@medusajs/types";
import { Locale } from "@lib/data/locales";
const PUBLIC_STORE = process.env.NEXT_PUBLIC_STORE;
const getSideMenuItems = () => {
  const baseItems = [{
    key: "Home",
    href: "/"
  }, {
    key: "Concerts",
    href: "/#concerts"
  }, {
    key: "Store",
    href: "https://tumerchan.com/collections/vangoura"
  }, {
    key: "Chords",
    href: "/chords"
  }, {
    key: "Press",
    href: "/press"
  }];
  if (PUBLIC_STORE) {
    baseItems.push({
      key: "Account",
      href: "/account"
    });
    baseItems.push({
      key: "Cart",
      href: "/cart"
    });
  }
  return baseItems;
};
const SideMenuItems = getSideMenuItems();
type SideMenuProps = {
  regions: HttpTypes.StoreRegion[] | null;
  countryCode: string;
  locales: Locale[] | null;
  currentLocale: string | null;
};
const SideMenu = t0 => {
  const $ = _c(8);
  const {
    regions,
    countryCode,
    locales,
    currentLocale
  } = t0;
  const countryToggleState = useToggleState();
  const languageToggleState = useToggleState();
  const t = useTranslations("store");
  let t1;
  if ($[0] !== countryCode || $[1] !== countryToggleState || $[2] !== currentLocale || $[3] !== languageToggleState || $[4] !== locales || $[5] !== regions || $[6] !== t) {
    t1 = <div className="h-full"><div className="flex items-center justify-end h-full"><Popover className="h-full flex">{t2 => {
            const {
              open,
              close
            } = t2;
            return <><div className="relative flex h-full"><Popover.Button data-testid="nav-menu-button" aria-label={t("Menu")} className="relative h-full flex items-center transition-all ease-out duration-200 focus:outline-none hover:text-ui-fg-base"><BarsThree /></Popover.Button></div><Transition show={open} as={Fragment} enter="transition ease-out duration-150" enterFrom="opacity-0" enterTo="opacity-100 backdrop-blur-2xl" leave="transition ease-in duration-150" leaveFrom="opacity-100 backdrop-blur-2xl" leaveTo="opacity-0"><PopoverPanel className="flex flex-col absolute w-full pr-4 sm:pr-0 sm:w-1/3 2xl:w-1/4 sm:min-w-min h-[calc(100vh-1rem)] z-30 inset-x-0 text-sm text-ui-fg-on-color m-2 backdrop-blur-2xl"><div data-testid="nav-menu-popup" className="flex flex-col h-full bg-[rgba(3,7,18,0.5)] rounded-rounded justify-between p-6"><div className="flex justify-end" id="xmark"><button data-testid="close-menu-button" aria-label={t("Close")} onClick={close}><XMark /></button></div><ul className="flex flex-col gap-6 items-start justify-start font-vangoura lowercase">{SideMenuItems.map(t3 => {
                        const {
                          key,
                          href
                        } = t3;
                        return <li key={key}>{href.startsWith("/") ? <ClientLink href={href} className="text-4xl leading-10 hover:text-ui-fg-disabled" onClick={close} data-testid={`${key.toLowerCase()}-link`}>{t(key)}</ClientLink> : <a href={href} className="text-4xl leading-10 hover:text-ui-fg-disabled" onClick={close} data-testid={`${key.toLowerCase()}-link`} target="_blank">{t(key)}</a>}</li>;
                      })}</ul><div className="flex flex-col gap-y-6">{!!locales?.length && <div className="flex justify-between" onMouseEnter={languageToggleState.open} onMouseLeave={languageToggleState.close}><LanguageSelect toggleState={languageToggleState} locales={locales} currentLocale={currentLocale} /><ArrowRightMini className={clx("transition-transform duration-150", languageToggleState.state ? "-rotate-90" : "")} /></div>}{PUBLIC_STORE && <div className="flex justify-between" onMouseEnter={countryToggleState.open} onMouseLeave={countryToggleState.close}>{regions && <CountrySelect toggleState={countryToggleState} regions={regions} countryCode={countryCode} />}<ArrowRightMini className={clx("transition-transform duration-150", countryToggleState.state ? "-rotate-90" : "")} /></div>}<Text className="flex justify-between txt-compact-small">© {new Date().getFullYear()} vangoura.{" "}{t("All rights reserved")}.</Text></div></div></PopoverPanel></Transition></>;
          }}</Popover></div></div>;
    $[0] = countryCode;
    $[1] = countryToggleState;
    $[2] = currentLocale;
    $[3] = languageToggleState;
    $[4] = locales;
    $[5] = regions;
    $[6] = t;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
};
export default SideMenu;